export const API = '/api/dashboard/acolhimento/crianca/atividades';
export const API_ROTINA = '/api/dashboard/acolhimento/crianca/atividades-rotina';
export const ROTA_IMPRESSAO = 'acolhimento.crianca.atividades.imprimir';

export const STATUS = [
  'Aberto', 'Em andamento', 'Cancelado', 'Realizado', 'Finalizado', 'Inativo',
];

export function opcoesStatus(todos = false) {
  const opcoes = STATUS.map(status => ({ id: status, value: status }));
  return todos ? [{ id: '', value: 'Todos' }].concat(opcoes) : opcoes;
}

export function dataApi(valor) {
  if (!valor) return '';
  if (valor instanceof Date) {
    if (Number.isNaN(valor.getTime())) return '';
    return [valor.getFullYear(), String(valor.getMonth() + 1).padStart(2, '0'),
      String(valor.getDate()).padStart(2, '0')].join('-');
  }
  const texto = String(valor).trim();
  const brasileira = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(texto);
  if (brasileira) return `${brasileira[3]}-${brasileira[2]}-${brasileira[1]}`;
  return /^\d{4}-\d{2}-\d{2}/.test(texto) ? texto.slice(0, 10) : texto;
}

export function horaApi(valor) {
  return valor ? String(valor).slice(0, 5) : '';
}

export function formatarDataHora(data, hora) {
  const valor = dataApi(data);
  if (!valor) return '-';
  const partes = valor.split('-');
  const dia = partes.length === 3 ? `${partes[2]}/${partes[1]}/${partes[0]}` : valor;
  return hora ? `${dia} ${horaApi(hora)}` : dia;
}

export function formatarHistorico(valor) {
  if (!valor) return '-';
  // A API retorna a data/hora no fuso configurado no Laravel, sem converter
  // datas sem timezone para UTC no navegador.
  const partes = String(valor).split(/[ T]/);
  return formatarDataHora(partes[0], partes[1]);
}

export function statusClasse(status) {
  const cores = {
    Aberto: 'info', 'Em andamento': 'primary', Cancelado: 'danger',
    Realizado: 'success', Finalizado: 'dark', Inativo: 'secondary',
  };
  return `badge badge-${cores[status] || 'secondary'}`;
}

export function mensagemErro(erro, padrao) {
  const dados = erro && erro.response && erro.response.data;
  if (dados && dados.errors) {
    const chave = Object.keys(dados.errors)[0];
    const mensagens = dados.errors[chave];
    if (Array.isArray(mensagens) && mensagens.length) return mensagens[0];
    if (typeof mensagens === 'string') return mensagens;
  }
  return dados && dados.message ? dados.message : padrao;
}

export function notificar(vm, tipo, texto) {
  const snack = vm.$snack;
  if (snack && typeof snack[tipo] === 'function') {
    snack[tipo]({ text: texto });
  } else if (snack && typeof snack.warning === 'function') {
    snack.warning({ text: texto });
  }
}

export function imprimirConteudo(vm) {
  // A listagem original chama print(), disponibilizado pelo projeto.
  if (typeof vm.print === 'function') {
    vm.print();
    return;
  }
  imprimirBoxPrint(vm);
}

export function limparImpressaoAtividade() {
  const secao = document.getElementById('print');
  if (secao && secao.getAttribute('data-acolhimento-atividade') === '1') {
    secao.remove();
  }
  document.body.classList.remove('imprimindo-atividade-acolhimento');
  window.removeEventListener('afterprint', limparImpressaoAtividade);
}

export function imprimirBoxPrint(vm) {
  vm.$nextTick(() => {
    const original = document.getElementById('boxPrint');
    if (!original) {
      notificar(vm, 'warning', 'Não foi possível localizar o conteúdo para impressão.');
      return;
    }

    limparImpressaoAtividade();
    const copia = original.cloneNode(true);
    copia.removeAttribute('id');
    copia.querySelectorAll('.no-print').forEach(elemento => elemento.remove());

    let secao = document.getElementById('print');
    if (!secao) {
      secao = document.createElement('div');
      secao.id = 'print';
      document.body.appendChild(secao);
    }
    secao.innerHTML = '';
    secao.setAttribute('data-acolhimento-atividade', '1');
    secao.appendChild(copia);
    document.body.classList.add('imprimindo-atividade-acolhimento');
    window.addEventListener('afterprint', limparImpressaoAtividade);

    try {
      window.print();
    } catch (erro) {
      limparImpressaoAtividade();
      notificar(vm, 'warning', 'Erro ao abrir a impressão.');
    }
  });
}
